export type { DecisionLabel, EditorDraft, ExportInput } from './types';
export { DECISION_LABELS, suggestDecision, explainDecision } from './types';
export type { DecisionInputs } from './types';
export { generateEmail, buildMailtoUri } from './email';
export type { EmailExport } from './email';
export { generatePdf } from './pdf';
export { generateJson } from './json';

/** Browser-side download trigger: creates a temporary <a download> and clicks it. */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after the click handler returns.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
